import { get, isNil } from "lodash";
import { NODE_TYPES } from "utils/constants";

export const STEP_KINDS = {
  SCREEN: "SCREEN",
  FORM: "FORM",
  WAIT: "WAIT",
  ACTION: "ACTION",
  ROUTE: "ROUTE",
};

export const STEP_TABS = {
  MAIN: "main",
  FIELDS: "fields",
  NEXT: "next",
  AUTOMATIONS: "automations",
  SETTINGS: "settings",
};

export const FAILURE_MODES = {
  STOP: "STOP",
  CONTINUE: "CONTINUE",
};

const PUBLISHED_STATUS = "published";

const KIND_BY_NODE_TYPE = {
  [NODE_TYPES.STATUS]: STEP_KINDS.SCREEN,
  [NODE_TYPES.FORM_STEP]: STEP_KINDS.FORM,
  [NODE_TYPES.AWAIT_SIGNATURE]: STEP_KINDS.WAIT,
  [NODE_TYPES.AWAIT_PAYMENT]: STEP_KINDS.WAIT,
  [NODE_TYPES.AWAIT_MANAGEMENT_ACK]: STEP_KINDS.WAIT,
  [NODE_TYPES.AWAIT_TERMINATION_ACK]: STEP_KINDS.WAIT,
  [NODE_TYPES.TIMER]: STEP_KINDS.WAIT,
  [NODE_TYPES.JOIN]: STEP_KINDS.WAIT,
  [NODE_TYPES.DECISION]: STEP_KINDS.ROUTE,
};

export const stepKind = (nodeType) =>
  KIND_BY_NODE_TYPE[nodeType || NODE_TYPES.STATUS] || STEP_KINDS.ACTION;

export const isWaitingType = (nodeType) =>
  stepKind(nodeType) === STEP_KINDS.WAIT;

const TABS_BY_KIND = {
  [STEP_KINDS.SCREEN]: [
    STEP_TABS.MAIN,
    STEP_TABS.FIELDS,
    STEP_TABS.NEXT,
    STEP_TABS.SETTINGS,
  ],
  [STEP_KINDS.ROUTE]: [STEP_TABS.NEXT, STEP_TABS.SETTINGS],
};

const DEFAULT_TABS = [STEP_TABS.MAIN, STEP_TABS.NEXT, STEP_TABS.SETTINGS];

const TAB_ALIASES = { [STEP_TABS.AUTOMATIONS]: STEP_TABS.SETTINGS };

export const tabKeys = (nodeType) =>
  TABS_BY_KIND[stepKind(nodeType)] || DEFAULT_TABS;

const BAR_TAB_OF = { [STEP_TABS.FIELDS]: STEP_TABS.MAIN };

export const barTabs = (nodeType) =>
  tabKeys(nodeType).filter((key) => isNil(BAR_TAB_OF[key]));

export const barTab = (tab) => BAR_TAB_OF[tab] || tab;

export const shownTab = (nodeType, requested) => {
  const keys = tabKeys(nodeType);
  const wanted = TAB_ALIASES[requested] || requested;
  return keys.includes(wanted) ? wanted : keys[0];
};

export const failureMode = (config) =>
  get(config, "continueOnError") ? FAILURE_MODES.CONTINUE : FAILURE_MODES.STOP;

export const withFailureMode = (config, mode) => {
  const { continueOnError, ...rest } = config || {};
  return mode === FAILURE_MODES.CONTINUE
    ? { ...rest, continueOnError: true }
    : rest;
};

export const screenVersions = (data = {}) => {
  const published = get(data, "screenPublishedVersion") || null;
  const latest = get(data, "screenVersionNumber") || null;
  const latestIsDraft =
    !isNil(latest) &&
    get(data, "screenVersionStatus") !== PUBLISHED_STATUS &&
    (isNil(published) || Number(latest) > Number(published));
  return { published, draft: latestIsDraft ? latest : null };
};
